module.exports = __webpack_public_path__ + "static/media/mazda.1fadd2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main-layout/mazda.png
// module id = 820
// module chunks = 0